import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  updateAction(e) {
    const { submitter } = e
    const action = new URL(this.formTarget.action)

    if (submitter.value !== '') {
      action.searchParams.set('step', submitter.value)
      this.formTarget.action = action.toString()
    }
  }
}
